export const SET_DEFAULT_LOCALE_MUTATION = /* GraphQL */ `
  mutation ($input: TSUpdateDefaultLocaleInput!) {
    schema: updateDefaultLocale(input: $input)
  }
`;

export const ADD_LOCALE_MUTATION = /* GraphQL */ `
  mutation ($input: TSAddLocaleInput!) {
    schema: addLocale(input: $input)
  }
`;

export const REMOVE_LOCALE_MUTATION = /* GraphQL */ `
  mutation ($input: TSRemoveLocaleInput!) {
    schema: removeLocale(input: $input)
  }
`;
